import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import IncomingCashsDetailPayment from "./IncomingCashsDetailPayment";
import { IncomingCashsDetailFooter } from "./IncomingCashsDetailFooter";
import { useFetchIncomingCashPayment } from "../hooks/fetchDocument";
import { IncomingCashsModel } from "../models/IncomingCashsModel";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { EnumHelper } from "src/helpers/EnumHelper";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "src/components/Shared/NewForms/NFLookupPaymentRequests";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import IncomingCashsCustomerPaymentDetail from "../OperationTypesDetailsViews/IncomingCashsCustomerPaymentDetail";
import IncomingCashsReceivingFromBankDetail from "../OperationTypesDetailsViews/IncomingCashsReceivingFromBankDetail";
import IncomingCahsTransferFromAnotherAccountDetail from "../OperationTypesDetailsViews/IncomingCashsTransferFromAnotherAccountDetail";
import IncomingCashsWithdrowalFromCashRegisterDetail from "../OperationTypesDetailsViews/IncomingCashsWithdrowalFromCashRegisterDetail";
import IncomingCashsLoanRepaymentByEmployeeDetail from "../OperationTypesDetailsViews/IncomingCashsLoanRepaymentByEmployeeDetail";
import IncomingCashsCurrencyConversionDetail from "../OperationTypesDetailsViews/IncomingCashsCurrencyConversionDetail";
import IncomingCashsOtherPaymentDetail from "../OperationTypesDetailsViews/IncomingCashsOtherPaymentDetail";
import IncomingCashsVendorRefundDetail from "../OperationTypesDetailsViews/IncomingCashsVendorRefundDetail";
import IncomingCashsReturnFromAdvanceHolderDetail from "../OperationTypesDetailsViews/IncomingCashsReturnFromAdvanceHolderDetail";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupCashflowItem } from "src/components/Shared/NewForms/NFLookupCashflowItem";
import IncomingCashsLoanRepaymentDetail from "../OperationTypesDetailsViews/IncomingCashsLoanRepaymentDetail";

interface IProps {
  id?: string;
}

export const IncomingCashsDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IncomingCashsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Incoming Cashs");
  const { t } = useTranslation();
  const [selectedOpType, setSelectedOpType] = useState(0);

  const handleTypeChange = (value: any) => {
    setSelectedOpType(value);
  };
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchIncomingCashPayment({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.IncomingCashs.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  const operationType = watch("operationType");

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
        <NFTab title={"Payments"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
        </DocumentDetailViewToolbar>

        <Row>
          <Col sm={6}>
            <NFLookupInput title={"Operation type"} fieldName={"operationType"} items={EnumHelper.GetIncomingCashsPaymentType()} onValueChange={handleTypeChange} />
          </Col>
          <Col sm={6}>
            <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.GetPaymentRequestsStatus()} required />
          </Col>
        </Row>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={t("Document#")} required={true} fieldName={"documentNumber"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("ProcessedDate")} required={true} fieldName={"processedDate"} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName="companyId" title={t("Company")} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("PaymentDate")} fieldName={"paymentDate"} required={true} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={t("Amount")} fieldName={"amount"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.GetIncomingCashOperationType()} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupInput title={t("AsAListNoSplit")} fieldName={"amountOfPayments"} items={EnumHelper.GetOutgoingBankCashListSplitTypeEnum()} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName="divisionId" title={t("Division")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupPaymentRequests fieldName="paymentRequestId" title={t("PaymentRequests")} />
            </Col>
            <Col sm={6}>
              <NFLookupCashRegister fieldName="cashRegisterId" title={t("CashRegister")} required={true} />
            </Col>
          </Row>

          {operationType === 0 && <IncomingCashsCustomerPaymentDetail />}
          {operationType === 1 && <IncomingCashsReceivingFromBankDetail />}
          {operationType === 2 && <IncomingCahsTransferFromAnotherAccountDetail />}
          {operationType === 3 && <IncomingCashsWithdrowalFromCashRegisterDetail />}
          {operationType === 4 && <IncomingCashsLoanRepaymentDetail />}
          {operationType === 5 && <IncomingCashsLoanRepaymentByEmployeeDetail />}
          {operationType === 6 && <IncomingCashsCurrencyConversionDetail />}
          {operationType === 7 && <IncomingCashsOtherPaymentDetail />}
          {operationType === 8 && <IncomingCashsVendorRefundDetail />}
          {operationType === 9 && <IncomingCashsReturnFromAdvanceHolderDetail />}
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <Row>
            <Col md={6}>
              <NFLookupBaseDocuments title={t("BaseDocument")} fieldName="baseDocumentAtId" />
            </Col>
            <Col md={6}>
              <NFLookupCashflowItem fieldName="cashFlowItemId" title={t("CashFlowItem")} required />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <NFTextInput title={t("CreatedUser")} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col md={6}>
              <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} required />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <NFTextInput fieldName="comment" title={t("Comment")} />
            </Col>
          </Row>
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <IncomingCashsDetailPayment />
        </NFTabContainer>
        {/* )} */}
      </div>
      <IncomingCashsDetailFooter />
    </FormProvider>
  );
};
